import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { statesLong } from "../config/utils";
import Grid2 from "@mui/material/Grid2";
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Typography from "@mui/material/Typography";
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import { PatternFormat } from 'react-number-format';
import FormLabel from "@mui/material/FormLabel";
import {useSxStyles as sx} from "../styles/sxStyles";

const PayorInfo = (props) => {
    const payorInfo = props.payorInfo;
    const setPayorInfo = props.setPayorInfo;
    const clearValues = props.clearValues;
    const { register, reset } = useForm();

    const handleNameChange = (e) => {
        const val = e.target.value;
        setPayorInfo({...payorInfo, posterName: val});
    }

    const handleAddressChange = (e) => {
        const val = e.target.value;
        setPayorInfo({...payorInfo, posterAddress: val});
    }

    const handleCityChange = (e) => {
        const val = e.target.value;
        setPayorInfo({...payorInfo, posterCity: val});
    }

    const handleStateChange = (e) => {
        const val = e.target.value;
        setPayorInfo({...payorInfo, posterState: val});
    }

    const handleZipChange = (values) => {
        setPayorInfo({...payorInfo, posterZip: values});
    }

    const handlePhoneChange = (values) => {
        setPayorInfo({...payorInfo, posterPhone: values});
    }

    const handleEmailChange = (e) => {
        const val = e.target.value;
        setPayorInfo({...payorInfo, posterEmail: val});
    }

    useEffect(() => {
        if (clearValues) {
            reset({
                payorName: null,
                payorAddress: null,
                payorCity: null,
                payorState: '',
                payorZip: '',
                payorPhone: '',
                payorEmail: null
            });
        }
    }, [clearValues]);

    return (
        (<Paper elevation={3} sx={sx.controlPanel}>
            <Typography variant='h6' component='h2' color='primary' sx={{marginBottom: '.5rem'}}>Enter Payor Information</Typography>
            <Grid2 container spacing={1} alignItems='top'>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6
                    }}>
                    <FormControl
                        required
                        fullWidth
                        {...register('payorName')}
                    >
                        <FormLabel shrink={true} htmlFor='payorName' required sx={sx.inputLabel}>Payor Name</FormLabel>
                        <TextField
                            name="payorName"
                            variant='outlined'
                            fullWidth
                            onChange={handleNameChange}
                            on
                            slotProps={{
                                htmlInput: {id: 'payorName', maxLength: 100, sx: sx.textbox }
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6
                    }}>
                    <FormControl
                        fullWidth
                        {...register('payorAddress')}
                    >
                        <FormLabel shrink={true} htmlFor='payorAddress' sx={sx.inputLabel}>Payor Address</FormLabel>
                        <TextField
                            name="payorAddress"
                            variant='outlined'
                            fullWidth
                            onChange={handleAddressChange}
                            slotProps={{
                                htmlInput: {id: 'payorAddress', maxLength: 100, sx: sx.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6
                    }}>
                    <FormControl
                        fullWidth
                        {...register('payorCity')}
                    >
                        <FormLabel shrink={true} htmlFor='payorCity' sx={sx.inputLabel}>Payor City</FormLabel>
                        <TextField
                            name="payorCity"
                            variant='outlined'
                            fullWidth
                            onChange={handleCityChange}
                            slotProps={{
                                htmlInput: {id: 'payorCity', maxLength: 100, sx: sx.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6,
                        xl: 3
                    }}>
                    <FormControl
                        fullWidth
                        {...register('payorState')}
                    >
                        <FormLabel shrink={true} htmlFor='payorState' sx={sx.inputLabel}>Payor State</FormLabel>
                        <Select
                            name='payorState'
                            id='payorState'
                            native
                            variant='outlined'
                            fullWidth
                            sx={{height: '2rem'}}
                            onChange={handleStateChange}
                        >
                            <option key='none' value=''></option>
                            { statesLong.map((_state) => (
                                <option key={_state.key} value={_state.value}>{_state.value}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6,
                        xl: 3
                    }}>
                    <FormControl
                        fullWidth
                        {...register('payorZip')}
                    >
                        <FormLabel htmlFor={'payorZip'} shrink={true} sx={sx.inputLabel}>Payor Zip</FormLabel>
                        <PatternFormat
                            name='payorZip'
                            customInput={TextField}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            format="#####"
                            onValueChange={handleZipChange}
                            InputProps={{
                                style: sx.numberbox
                            }}
                            inputProps={{
                                id: 'payorZip'
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        lg: 6
                    }}>
                    <FormControl
                        fullWidth
                        {...register('payorPhone')}
                    >
                        <FormLabel shrink={true} htmlFor='payorPhone' sx={sx.inputLabel}>Payor Phone</FormLabel>
                        <PatternFormat
                            name='payorPhone'
                            id='payorPhone'
                            customInput={TextField}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            format="(###) ###-####"
                            onValueChange={handlePhoneChange}
                            InputProps={{
                                style: sx.numberbox
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    sx={{marginBottom: '1rem'}}
                    size={{
                        xs: 12,
                        lg: 6
                    }}>
                    <FormControl
                        fullWidth
                        {...register('payorEmail')}
                    >
                        <FormLabel shrink={true} htmlFor='payorEmail' sx={sx.inputLabel}>Payor Email</FormLabel>
                        <TextField
                            name='payorEmail'
                            variant='outlined'
                            fullWidth
                            onChange={handleEmailChange}
                            slotProps={{
                                htmlInput: {id: 'payorEmail', sx: sx.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
            </Grid2>
        </Paper>)
    );
}

export default PayorInfo;
